import { useMutation, useQueryClient } from '@tanstack/vue-query';
import { getApi } from '../api';
import type { ShipmentExceptionRow } from '../shipment-exception-types';

export type DeleteAccountExceptionClosedVariables = {
  accountId: number;
  exceptionId: number;
  shipmentId?: number;
};

export default function useDeleteAccountExceptionClosed() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      accountId,
      exceptionId,
    }: DeleteAccountExceptionClosedVariables): Promise<ShipmentExceptionRow> => {
      const { api, baseURL } = getApi();
      const res = await api.delete(
        `/api/v2/accounts/${accountId}/exceptions/${exceptionId}/closed`,
        { baseURL },
      );
      return (res.data?.data ?? res.data) as ShipmentExceptionRow;
    },
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: ['account-exceptions', variables.accountId],
      });
      queryClient.invalidateQueries({
        queryKey: ['account-exception-metrics', variables.accountId],
      });
      if (variables.shipmentId) {
        queryClient.invalidateQueries({
          queryKey: [
            'account-shipment-exceptions',
            variables.accountId,
            variables.shipmentId,
          ],
        });
      } else {
        queryClient.invalidateQueries({
          queryKey: ['account-shipment-exceptions', variables.accountId],
        });
      }
      queryClient.invalidateQueries({
        queryKey: ['account-shipments', variables.accountId],
      });
    },
  });
}
